import { render, staticRenderFns } from "./MenuArchivo.vue?vue&type=template&id=f04e45d0&scoped=true&"
import script from "./MenuArchivo.vue?vue&type=script&lang=js&"
export * from "./MenuArchivo.vue?vue&type=script&lang=js&"
import style0 from "./MenuArchivo.vue?vue&type=style&index=0&id=f04e45d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04e45d0",
  null
  
)

export default component.exports